import React from "react"
import "./goals.scss"
import Targets from "./Targets";
import Goals from "./Goals";

export default function Quest() {

    return(
        <div className={'goals'}>
            <h1>The Quest</h1>
            <Goals/>
            <Targets/>
        </div>
    )
}